// extracted by mini-css-extract-plugin
module.exports = {"root":"Short-module__root___2QSZ0","title":"Short-module__title___3VOOC Fonts-module__at___1f_7n","item":"Short-module__item___1m3mf Fonts-module__bt___102gf"};